import { LabelRegular, YStack } from 'smoothie';

import { FootnoteTitle, type FootnoteTitleProps } from './FootnoteTitle';
import {
    INVESTMENT_FRUITFUL_WHOLLY_OWNED,
    INVESTMENT_NOT_FDIC_INSURED,
} from './legal';

export const InvestmentManagementDisclosure = ({
    color = '$gray900',
    titleColor,
    superscript,
}: {
    color?: string;
    titleColor?: string;
    superscript?: FootnoteTitleProps['superscript'];
}) => {
    return (
        <YStack gap={12}>
            <FootnoteTitle
                title="Investment Management"
                superscript={superscript}
                color={titleColor}
            />
            <LabelRegular color={color}>
                {INVESTMENT_FRUITFUL_WHOLLY_OWNED}
            </LabelRegular>
            <LabelRegular color={color}>
                {INVESTMENT_NOT_FDIC_INSURED}
            </LabelRegular>
        </YStack>
    );
};
